import React from "react";
import styles from "./styles.css";
import Banner from "./images/no-car-found-blue.svg";

const BannerNoCarFoundRevamp = () => {
    return (
        <div styleName={"bannerWrapper"}>
            <img src={Banner} />
            <div styleName={"styles.titleWrapper"}>
                <p styleName={"styles.heading"}>No cars found!</p>
                <p styleName={"styles.subHeading"}>No car is available for selected criteria. Try using the exact car model name, type, etc.</p>
            </div>
        </div>
    );
};

export default BannerNoCarFoundRevamp;
